// TODO: replace with API hook once the audit-history endpoint is wired
// (see BFF route: GET /api/dsc-workbench/approvals/{approvalId}/audit)

export type AuditTabId =
  | "view-all-notes"
  | "pre-approval-history"
  | "advance"
  | "status-history"
  | "aggregator-validation";

export type AuditTab = {
  id: AuditTabId;
  label: string;
};

export const AUDIT_TABS: AuditTab[] = [
  { id: "view-all-notes", label: "View All Notes" },
  { id: "pre-approval-history", label: "Pre-Approval Change History" },
  { id: "advance", label: "Advance" },
  { id: "status-history", label: "Status History" },
  { id: "aggregator-validation", label: "Aggregator Validation" },
];
